import {
  greenWallet,
  orangeCoin,
  orangeGrowth,
  purpleGrowth,
} from "@/common/components/icons/svg-icons";

export const retailerCards = [
  {
    id: 1,
    name: "DRF Balance",
    value: 20000,
    icon: greenWallet,
    color: "#43A047",
  },
  {
    id: 2,
    name: "Recent Fund Allocation",
    value: 120000,
    icon: orangeCoin,
    color: "#FF9800",
  },
  {
    id: 3,
    name: "Total Allocations",
    value: 120000,
    icon: purpleGrowth,
    color: "#673AB7",
  },
  {
    id: 4,
    name: "Total Request Submitted",
    value: 30,
    icon: orangeGrowth,
    color: "#FF5722",
  },
];

export const financialManagementTableHeaders = [
  "Request Date",
  "Submitted By",
  "Amount Requested",
  "Status",
];

export const financialManagementTableKeys = [
  "date",
  "officer_name",
  "amount",
  "request_status",
];

export const getFinancialManagementTableData = (_: any) => [
  {
    id: "1",
    date: { value: "2025-07-01", type: "string" },
    officer_name: { value: "Jane Doe", type: "string" },
    amount: { value: "1200", type: "string" },
    request_status: {
      value: "accepted",
      type: "string",
    },
  },
  {
    id: "2",
    date: { value: "2025-06-28", type: "string" },
    officer_name: { value: "John Smith", type: "string" },
    amount: { value: "450", type: "string" },
    request_status: {
      value: "pending",
      type: "string",
    },
  },
  {
    id: "3",
    date: { value: "2025-06-25", type: "string" },
    officer_name: { value: "Amaka Okafor", type: "string" },
    amount: { value: "870", type: "string" },
    request_status: {
      value: "rejected",
      type: "string",
    },
  },
  {
    id: "4",
    date: { value: "2025-06-20", type: "string" },
    officer_name: { value: "Samuel Johnson", type: "string" },
    amount: { value: "2200", type: "string" },
    request_status: {
      value: "accepted",
      type: "string",
    },
  },
  {
    id: "5",
    date: { value: "2025-06-18", type: "string" },
    officer_name: { value: "Fatima Yusuf", type: "string" },
    amount: { value: "500", type: "string" },
    request_status: {
      value: "pending",
      type: "string",
    },
  },
  {
    id: "6",
    date: { value: "2025-06-15", type: "string" },
    officer_name: { value: "Michael Eze", type: "string" },
    amount: { value: "1300", type: "string" },
    request_status: {
      value: "accepted",
      type: "string",
    },
  },
  {
    id: "7",
    date: { value: "2025-06-12", type: "string" },
    officer_name: { value: "Grace Nwosu", type: "string" },
    amount: { value: "950", type: "string" },
    request_status: {
      value: "rejected",
      type: "string",
    },
  },
  {
    id: "8",
    date: { value: "2025-06-10", type: "string" },
    officer_name: { value: "Peter Obi", type: "string" },
    amount: { value: "3000", type: "string" },
    request_status: {
      value: "accepted",
      type: "string",
    },
  },
  {
    id: "9",
    date: { value: "2025-06-08", type: "string" },
    officer_name: { value: "Linda Ikeji", type: "string" },
    amount: { value: "710", type: "string" },
    request_status: {
      value: "pending",
      type: "string",
    },
  },
  {
    id: "10",
    date: { value: "2025-06-05", type: "string" },
    officer_name: { value: "Ahmed Musa", type: "string" },
    amount: { value: "1120", type: "string" },
    request_status: {
      value: "rejected",
      type: "string",
    },
  },
];

export const newFundRequestForm = [
  {
    inputType: "label",
    label: "Requesting Officer Details",
  },
  {
    inputType: "text",
    name: "firstName",
    prompt: "First Name",
    rules: { required: true },
    placeholder: "Enter First Name",
    isFullWidth: false,
    required: true,
  },
  {
    inputType: "text",
    name: "lastname",
    prompt: " Last Name",
    placeholder: "Enter Last Name",
    required: true,
    isFullWidth: false,
  },
  {
    inputType: "text",
    name: "email",
    prompt: "Email",
    placeholder: "Enter Email Address",
    rules: { required: true },
    isFullWidth: false,
    required: true,
  },
  {
    inputType: "text",
    name: "number",
    prompt: "Phone Number",
    placeholder: "Enter Phone Number",
    required: true,
    isFullWidth: false,
  },
  {
    inputType: "label",
    label: "Request Information",
  },
  {
    inputType: "text",
    name: "request_amount",
    prompt: "Request Amount",
    placeholder: "120,000",
    required: true,
    isFullWidth: false,
  },
  {
    inputType: "date",
    name: "request_date",
    prompt: "Request date",
    // placeholder: "",
    required: true,
    isFullWidth: false,
  },
  {
    inputType: "textarea",
    name: "purpose",
    prompt: "Purpose of request",
    placeholder: "make it worth it",
    required: true,
    isFullWidth: true,
  },
];

export const activityLogTableHeaders = ["Date", "Time", "User"];
export const activityLogTableKey = ["date", "time", "user"];

export const getActivityLogTableData = () => [
  {
    id: "1",
    date: { value: "2025-07-01", type: "string" },
    time: { value: "09:23 AM", type: "string" },
    user: { value: "Doris Osuya", type: "string" },
  },
  {
    id: "2",
    date: { value: "2025-07-01", type: "string" },
    time: { value: "10:10 AM", type: "string" },
    user: { value: "Musa Muhammed", type: "string" },
  },
  {
    id: "3",
    date: { value: "2025-07-01", type: "string" },
    time: { value: "10:45 AM", type: "string" },
    user: { value: "Jane Doe", type: "string" },
  },
  {
    id: "4",
    date: { value: "2025-07-01", type: "string" },
    time: { value: "11:20 AM", type: "string" },
    user: { value: "John Smith", type: "string" },
  },
  {
    id: "5",
    date: { value: "2025-07-01", type: "string" },
    time: { value: "12:00 PM", type: "string" },
    user: { value: "Alex Johnson", type: "string" },
  },
  {
    id: "6",
    date: { value: "2025-07-01", type: "string" },
    time: { value: "01:15 PM", type: "string" },
    user: { value: "Emily Brown", type: "string" },
  },
  {
    id: "7",
    date: { value: "2025-07-01", type: "string" },
    time: { value: "02:40 PM", type: "string" },
    user: { value: "Michael Lee", type: "string" },
  },
  {
    id: "8",
    date: { value: "2025-07-01", type: "string" },
    time: { value: "03:05 PM", type: "string" },
    user: { value: "Sarah Kim", type: "string" },
  },
  {
    id: "9",
    date: { value: "2025-07-01", type: "string" },
    time: { value: "04:25 PM", type: "string" },
    user: { value: "Daniel Wright", type: "string" },
  },
  {
    id: "10",
    date: { value: "2025-07-01", type: "string" },
    time: { value: "05:55 PM", type: "string" },
    user: { value: "Chloe Davis", type: "string" },
  },
];
